<!--All Schools-->
<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstSchool"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--Selected-->

				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--School Name-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-school>
			<tr [pSelectableRow]="school">
				<td>
					<p-tableCheckbox [pSelectableRow]="school" [value]="school"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ school[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
